'use client'

import React, { useState } from 'react'
import { Button, useDocumentInfo } from '@payloadcms/ui'

/**
 * Controllo admin per la edit view dei Post (slot beforeDocumentControls): elimina il post E le sue
 * immagini ORFANE (cover/ogImage non usate da altri post o categorie). Affianca il pulsante "Elimina"
 * nativo, che resta per l'eliminazione del solo post. Chiama POST /api/post-delete-with-media.
 *
 * NB: Payload 3.x non espone uno slot per sostituire il "Delete" nativo → questo è additivo.
 */
const ENDPOINT = '/api/post-delete-with-media'

export default function DeletePostWithMedia() {
  const { id } = useDocumentInfo()
  const [busy, setBusy] = useState(false)

  // Solo nella edit view di un documento esistente (in "create" non c'è id).
  if (!id) return null

  const onClick = async () => {
    setBusy(true)
    try {
      // 1) dry-run: quante immagini risulterebbero orfane.
      const pre = await fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ id, dryRun: true }),
      })
      const preData = await pre.json().catch(() => ({}))
      if (!pre.ok) {
        window.alert(`Errore nel calcolo dei media: ${preData?.error || pre.status}`)
        return
      }
      const orphan: number[] = preData.orphanMedia ?? []
      const kept: number[] = preData.keptMedia ?? []
      const msg =
        orphan.length > 0
          ? `Eliminare il post e ${orphan.length} immagine/i associata/e non usata/e da altri contenuti?` +
            (kept.length ? `\n\n(${kept.length} immagine/i verrà/anno conservata/e perché in uso altrove.)` : '')
          : `Questo post non ha immagini orfane da rimuovere. Eliminare il post?`
      if (!window.confirm(msg)) return

      // 2) eliminazione effettiva (post + media orfani).
      const res = await fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ id, deleteMedia: true }),
      })
      const data = await res.json().catch(() => ({}))
      if (!res.ok) {
        window.alert(`Errore durante l'eliminazione: ${data?.error || res.status}`)
        return
      }
      window.location.href = '/admin/collections/posts'
    } finally {
      setBusy(false)
    }
  }

  return (
    <Button buttonStyle="secondary" size="small" onClick={onClick} disabled={busy}>
      {busy ? 'Eliminazione…' : 'Elimina con media…'}
    </Button>
  )
}
